import React from "react";
import {Route, Switch} from "react-router-dom";
import RouteService from "../services/routes/RouteService";
import OperationPage from "../pages/operations/OperationPage";
import {EOperationType, operationsWithIconUrls} from "../models/utils/EOperationType";
import EditOperationPage from "../pages/operations/EditOperationPage";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 *
 * @author Alizée Grand
 * @version 1.1
 * @creation 16/05/2022
 * @last_update 31/05/2022
 **/
class OperationRouter extends React.Component<WithTranslation> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <Switch>

                <Route exact path={RouteService.getEquipmentInstallation()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.InstallationEquipment].translateKeyName)}
                        currentOperationData={EOperationType.InstallationEquipment}
                    />
                </Route>

                <Route exact path={RouteService.getElementInstallation()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.InstallationElement].translateKeyName)}
                        currentOperationData={EOperationType.InstallationElement}
                    />
                </Route>

                <Route exact path={RouteService.getEquipmentUninstallation()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.UninstallationEquipment].translateKeyName)}
                        currentOperationData={EOperationType.UninstallationEquipment}
                    />
                </Route>

                 <Route exact path={RouteService.getElementUninstallation()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.UninstallationElement].translateKeyName)}
                        currentOperationData={EOperationType.UninstallationElement}
                    />
                </Route>

                <Route exact path={RouteService.getElementReplacement()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.ReplacementElement].translateKeyName)}
                        currentOperationData={EOperationType.ReplacementElement}
                    />
                </Route>

                <Route exact path={RouteService.getGeolocation()}>
                    <OperationPage
                        pageTitle={getTranslation(operationsWithIconUrls[EOperationType.Geolocate].translateKeyName)}
                        currentOperationData={EOperationType.Geolocate}
                    />
                </Route>
                
                <Route
                    exact
                    path={RouteService.getEditOperationWithParam()}
                    render={(props) => {
                        return (
                            <EditOperationPage {...props}/>
                        );
                    }}
                />

            </Switch>

        );

    };

}

export default withTranslation()(OperationRouter);
